// #516: Mitarbeiter archivieren statt löschen. Archivierte (profiles.status = 'Archiviert') erscheinen in
// keiner Auswahl mehr: zuweisbar wird abgeschaltet (fast alle Auswahllisten filtern darauf), die übrigen
// Listen filtern über istArchiviert. Bestehende Tickets, Zeiten usw. behalten den Namen.

export const ARCHIVIERT = 'Archiviert';

export const istArchiviert = (p: { status?: string | null }): boolean => (p.status ?? '').trim().toLowerCase() === 'archiviert';

export function ohneArchivierte<T extends { status?: string | null }>(liste: readonly T[]): T[] {
  return liste.filter(p => !istArchiviert(p));
}

/** Änderung an profiles beim Archivieren bzw. Wiederherstellen. */
export function archivPatch(archivieren: boolean): { status: string; zuweisbar: boolean } {
  return archivieren ? { status: ARCHIVIERT, zuweisbar: false } : { status: 'Aktiv', zuweisbar: true };
}
